import { useQuery } from '@tanstack/react-query'

import HttpClient from '@utils/HttpClient'

import type { operations, components } from '@/schema'

type GetAuthConfigurationResponse = operations['configuration']['responses']['200']['content']['application/json']

export type AuthClientsDTO = components['schemas']['AuthConfigurationResponse']

export function useAuthConfiguration() {
  return useQuery({
    queryKey: ['sign-in-clients'],
    queryFn: async () => {
      return HttpClient.get<GetAuthConfigurationResponse>('/api/.auth/configuration')
    },
    staleTime: Infinity,
  })
}